import { useIsFetching } from '@tanstack/react-query';
import { Loading } from '@pella/react-layout';

/**
 * A global loading indicator that shows when any react-query queries are fetching.
 * @returns {import("react").ReactElement | null}
 */
const GlobalLoading = () => {
  const isFetching = useIsFetching();

  return <Loading show={Boolean(isFetching)} />;
};

export default GlobalLoading;
